import {
  createRequestTypes,
  createActions,
} from 'app/store/actions/base-request.actions'

export const SOUNDS_ACTIONS = createRequestTypes('[Media] SOUNDS')
export const SONIDOS_ACTIONS = createRequestTypes('[Media] SONIDOS')

export const soundsActionCreators = createActions(SOUNDS_ACTIONS)
export const sonidosActionCreators = createActions(SONIDOS_ACTIONS)
